import { apiClient } from "../Config/ApiClient";

export const login = (body) => apiClient.post(`/auth/login`, body);

export const logout = (token) => apiClient.get(`/auth/logout`, { headers: {'Authorization': token} });

export const updateUser = (body, token) => apiClient.post(`/users/changePassword`, body, { headers: {'Authorization': token} });